import './GameStatusBadge.css';

export default function GameStatusBadge({
  status,
  priceCents,
  currency,
  isFree,
  subscriptionIncluded,
  accessVia,
  onlyAccessVia = false,
  cardCount = 0
}) {
  console.log('GameStatusBadge debug:', { status, priceCents, currency, isFree, subscriptionIncluded, accessVia, onlyAccessVia, cardCount });

  const displayCurrency = currency === 'RUB' ? '₽' : currency || '₽';
  const price = priceCents ? (priceCents / 100).toFixed(0) : 0;

  // На странице Мои игры показываем бейджи по access_via
  if (onlyAccessVia) {
    if (status === 'owned' || accessVia === 'purchase') {
      // Приобретенные: оранжевая иконка карточек + количество, "Полный набор"
      return (
        <>
          <span className="badge badge--orange">
            <img src="/icons/cards-orange.svg" alt="" className="badge-icon" />
            {cardCount}
          </span>
          <span className="badge badge--orange">Полный набор</span>
        </>
      );
    }
    if (accessVia === 'trial') {
      // Trial: зеленая иконка карточек + "7", "Полный набор {цена}"
      return (
        <>
          <span className="badge badge--green">
            <img src="/icons/cards-green.svg" alt="" className="badge-icon" />
            7
          </span>
          <span className="badge badge--orange">Полный набор {price}{displayCurrency}<span className="badge-old-price">790₽</span></span>
        </>
      );
    }
    if (accessVia === 'subscription') {
      return <span className="badge badge--primary">По подписке</span>;
    }
    if (accessVia === 'free') {
      // Бесплатные: зеленый бейдж "Бесплатно"
      return <span className="badge badge--green">Бесплатно</span>;
    }
    return null;
  }

  // На странице Рекомендуем
  if (status === 'owned') {
    return <span className="badge badge--success">Приобретено</span>;
  }

  const badges = [];

  // Пробная версия для личных игр (в общих случаях, если потребуется)
  if (accessVia === 'trial') {
    badges.push(<span key="trial" className="badge badge--primary">Пробная версия</span>);
  }

  if (isFree) {
    // Для бесплатных игр: зеленый бейдж "Бесплатно"
    badges.push(<span key="free" className="badge badge--green">Бесплатно</span>);
  } else {
    // Для рекомендованных платных игр: "7 бесплатно" и цена
    badges.push(
      <span key="free-trial" className="badge badge--green">
        <img src="/icons/cards-green.svg" alt="" className="badge-icon" />
        7 бесплатно
      </span>
    );
    badges.push(<span key="price" className="badge badge--orange">{price}{displayCurrency}<span className="badge-old-price">790₽</span></span>);
  }

  if (subscriptionIncluded) {
    badges.push(<span key="subscription" className="badge badge--primary">0 ₽ по подписке</span>);
  }

  console.log('Generated badges:', badges);
  return badges.length > 0 ? badges : null;
}
